import { API_BASE_URL } from '@/utils/env';
import { tokenStorage } from '@/utils/storage';
import type { ApiResponse } from '@/types';

async function request<T>(
  endpoint: string,
  options: RequestInit = {}
): Promise<ApiResponse<T>> {
  const token = tokenStorage.getToken();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(options.headers as Record<string, string> || {}),
  };

  const res = await fetch(`${API_BASE_URL}${endpoint}`, {
    ...options,
    headers,
  });

  const data: ApiResponse<T> = await res.json();

  if (!res.ok) {
    if (res.status === 401) {
      tokenStorage.removeToken();
      window.location.href = '/login';
    }
    throw new Error(data.message || 'Request failed');
  }

  return data;
}

export const http = {
  get<T>(endpoint: string) {
    return request<T>(endpoint);
  },
  post<T>(endpoint: string, body?: unknown) {
    return request<T>(endpoint, {
      method: 'POST',
      body: body ? JSON.stringify(body) : undefined,
    });
  },
  put<T>(endpoint: string, body?: unknown) {
    return request<T>(endpoint, {
      method: 'PUT',
      body: body ? JSON.stringify(body) : undefined,
    });
  },
};
